<template>
  <div>
  	<router-view></router-view>
  </div>
</template>

<script>
import List from './monitor/List'

export default {
  routes: [
    {
      path: "",
      redirect: "/monitor/list"
    },
    {
      path: "list",
      component: List,
      name: "Monitor list",
    }
  ]
}
</script>
